import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomVerticalFourSelectionComponent } from './custom-vertical-four-selection.component';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { CustomItemVerticalFourModule } from '../custom-item-vertical-four/custom-item-vertical-four.module';
import { CustomCarouselModule } from '../../../../spartacus/custom/shared/components/custom-carousel/custom-carousel.module';

@NgModule({
  declarations: [CustomVerticalFourSelectionComponent],
  exports: [CustomVerticalFourSelectionComponent],
  imports: [
    CommonModule,
    I18nModule,
    CustomItemVerticalFourModule,
    CustomCarouselModule,
    ConfigModule.withConfig({
      cmsComponents: {
        VerticalFourSelectionComponent: {
          component: CustomVerticalFourSelectionComponent,
        },
      },
    } as CmsConfig),
  ],
})
export class CustomVerticalFourSelectionModule {}
